export const blacklistedWords = ['卍', '↑', '1488'];
